import React from 'react';
import styled from 'styled-components';

import { Link } from 'components/core';
import { DutchieLogo } from 'assets/marketing/rebrand/dutchie-logo';
import { DutchieLogoColor } from 'assets/marketing/rebrand/dutchie-logo-color';

type HeaderLogoProps = {
  href?: string;
  route?: string;
  isDark?: boolean;
};

export function HeaderLogo({ href, route, isDark = false }: HeaderLogoProps): JSX.Element {
  return (
    <Link href={href} route={route}>
      <LogoLink data-testid='dutchie-icon' href={href}>
        {isDark ? (
          <DutchieLogoColor height='33px' flowerColor='var(--rds-gold-first)' wordmarkColor='var(--rds-cream)' />
        ) : (
          <DutchieLogo height='33px' color='white' />
        )}
      </LogoLink>
    </Link>
  );
}

const LogoLink = styled.a`
  line-height: 1;
  padding-top: 3px;
`;
